// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const catapult = defineModel({
  id: "catapult",
  batchId: "future",
  name: "Catapult",
  tags: ["scenery","catapult","low-poly","age-of-mcp","future","military"],
  summary: "A catapult — a torsion siege engine (parked: no combat system yet).",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.45,
  parts: () => [
      { geometry: new THREE.TorusGeometry(0.13, 0.03, 5, 10), color: "#5c3c20", position: [-0.1, 0.13, 0.22], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.5, 6), color: "#5c3c20", position: [-0.1, 0.13, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.13, 0.03, 5, 10), color: "#5c3c20", position: [-0.1, 0.13, -0.22], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.5, 6), color: "#5c3c20", position: [-0.1, 0.13, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.1), color: "#7a512c", position: [0, 0.18, 0.18] },
      { geometry: new THREE.BoxGeometry(0.7, 0.06, 0.1), color: "#7a512c", position: [0, 0.18, -0.18] },
      { geometry: new THREE.BoxGeometry(0.12, 0.06, 0.46), color: "#7a512c", position: [-0.28, 0.18, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.34, 0.06), color: "#7a512c", position: [0.04, 0.42, 0.16], rotation: [0, 0, 0.3] },
      { geometry: new THREE.BoxGeometry(0.06, 0.34, 0.06), color: "#7a512c", position: [0.04, 0.42, -0.16], rotation: [0, 0, 0.3] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.4, 6), color: "#3a3f44", position: [-0.02, 0.47, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.6, 0.05, 0.05), color: "#5c3c20", position: [0.12, 0.59, 0], rotation: [0, 0, 0.55] },
      { geometry: new THREE.SphereGeometry(0.07, 7, 5, 0, 6.283185, 0, 1.570796), color: "#7a512c", position: [0.28, 0.75, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 7, 5), color: "#7d776b", position: [0.28, 0.77, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.42), color: "#7a512c", position: [0.34, 0.51, 0] },
      { geometry: new THREE.CylinderGeometry(0.01, 0.01, 0.32, 4), color: "#b8a479", position: [-0.06, 0.45, 0], rotation: [0, 0, -0.7] },
    ],
  animations: [],
});
